var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 144,
    viewBox: "0 0 131 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.099 67.3079C102.422 55.2305 85.3856 31.6595 73.2262 26.5844C58.8772 20.5953 53.7952 28.3807 52.8984 40.3585C53.0977 49.142 57.4423 72.099 73.2262 93.6585M109.099 73.2963C118.067 55.3291 121.953 20.4153 102.821 24.4876C83.689 28.56 65.8524 59.2229 58.2793 74.7937",
    stroke: "url(#paint0_linear_4144_6464)",
    strokeWidth: 0.298937
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3077 49.3398C28.3845 49.3398 20.9115 78.3853 52.3001 87.3684C58.4781 88.8656 73.644 91.9797 84.8841 92.4588",
    stroke: "url(#paint1_linear_4144_6464)",
    strokeWidth: 0.298937
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2785 68.5223L22.0167 68.5891C22.9286 73.2065 24.6237 78.92 28.7078 84.2952C32.7932 89.6721 39.2619 94.7009 49.7054 97.9605C69.595 104.168 88.2857 98.25 93.3577 95.785C99.1741 92.9583 104.124 90.446 108.635 86.9084C113.149 83.3689 117.219 78.8068 121.288 71.8835C127.539 61.2479 124.296 48.6311 122.831 42.928C122.769 42.6868 122.71 42.4579 122.655 42.2421L122.389 42.2725C122.373 43.0331 122.384 43.9389 122.396 44.9435C122.417 46.7079 122.442 48.777 122.328 50.8997C122.15 54.225 121.633 57.6308 120.242 60.0952C119.868 60.7578 119.495 61.4444 119.11 62.1508C115.875 68.095 111.875 75.4451 100.544 81.7238C94.1875 85.246 89.3267 87.6799 84.3003 89.3356C79.2755 90.9908 74.0797 91.8702 67.0533 92.2762C55.8368 92.9244 44.2158 88.5854 39.8037 86.3322C36.9788 84.4589 32.9987 81.288 29.5215 77.9399C27.7819 76.2648 26.1702 74.5474 24.8929 72.9278C23.6138 71.3059 22.6777 69.7917 22.2785 68.5223Z",
    fill: "#C6C5CA",
    stroke: "white",
    strokeWidth: 0.270552
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4102 96.2072L37.4228 93.6607C38.3861 92.4419 38.8677 91.8325 39.4433 91.516C40.222 91.0878 41.1422 90.9976 41.9892 91.2663C42.6153 91.4649 43.2062 91.969 44.388 92.9774C45.4665 93.8977 46.0057 94.3578 46.2951 94.8999C46.6866 95.6333 46.7818 96.4889 46.5612 97.2904C46.3981 97.8828 45.9732 98.4502 45.1235 99.5851L42.9856 102.44L35.4102 96.2072Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.108221
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.576158 134.015L32.3027 96.0056C33.0496 95.1109 34.3794 94.9922 35.2729 95.7405L43.6353 102.744C44.5289 103.492 44.6478 104.824 43.9009 105.719L12.1743 143.728L0.576158 134.015Z",
    fill: "url(#paint2_linear_4144_6464)",
    stroke: "url(#paint3_linear_4144_6464)",
    strokeWidth: 0.108221
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6616 64.4676C22.4732 56.5181 29.4866 39.1297 39.2475 32.2182C54.9395 21.1068 60.3505 20.9529 64.1383 20.0229C73.337 17.7646 90.1113 14.8737 104.992 24.088C116.637 31.299 120.233 44.865 121.225 49.8334C121.856 45.4973 121.87 36.4758 120.355 33.8741C118.461 30.6221 106.286 16.5298 100.933 14.0608C95.2333 11.4315 66.5732 5.93063 48.9873 16.4998C31.4015 27.069 22.4148 41.1912 21.3326 46.3403C20.3011 51.2485 21.0303 60.0412 21.6616 64.4676Z",
    fill: "url(#paint4_angular_4144_6464)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6664 90.084C108.99 82.7909 126.908 59.5458 121.149 37.8954C115.389 16.2449 88.2987 5.01356 60.9755 12.3066C33.6523 19.5997 15.7336 42.8448 21.4932 64.4953C27.2528 86.1457 54.3432 97.3771 81.6664 90.084Z",
    stroke: "white",
    strokeWidth: 1.62331
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4144_6464",
    x1: 104.316,
    y1: -33.6038,
    x2: 84.6434,
    y2: 93.6486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF9D61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4144_6464",
    x1: 49.3105,
    y1: 100.843,
    x2: 59.5063,
    y2: 61.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF9D61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4144_6464",
    x1: 41.63,
    y1: 94.3092,
    x2: 4.42891,
    y2: 137.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4144_6464",
    x1: 38.1128,
    y1: 99.7293,
    x2: 10.1938,
    y2: 131.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_4144_6464",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.3371 11.6215) rotate(-106.364) scale(4.80158 9.09369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.246805e45c24b08f205358ecea1624ff.svg";
export { ForwardRef as ReactComponent };